import { initialState, State, Action } from 'store/store';

export const setTracker = (state: State = initialState, { data }: Action): State => {
  const nextState = {
    ...state,
    tracker: data,
  };

  return nextState;
};
